import * as z from "zod";

import { procurementCommentSchema } from "./procurement-comment";
import { userSchema } from "./user";

export const procurementCommentWithCreatedBySchema =
  procurementCommentSchema.extend({
    createdBy: userSchema,
  });

export type ProcurementCommentWithCreatedBy = z.infer<
  typeof procurementCommentWithCreatedBySchema
>;
